<template>
  <v-container v-if="collateral" justify="center" :style="{'margin-bottom': 0+'px',opacity: collateral.payed?0.5:1}">
    <v-card align="center" style="width: 100%">
      <v-container>
        <v-row style="justify-content: center">
          <b><span>collateral</span> </b>
        </v-row>
        <v-row>
          <v-col>
            <v-container class="pt-0 pb-0 pr-0">
              <v-row>
                <v-col style="text-align: start">
                  <div>
                    <v-icon color="success">
                      mdi-check-circle-outline
                    </v-icon> {{ $t('CollateralView.Anonymous' ) }}
                  </div>
                </v-col>
              </v-row>
              <v-row style="padding:0;margin: 0">
                <v-col cols="auto" style="padding:0;margin: 0;text-align: left;align-self: center">
                  <i class="fas fa-arrow-down fa-2x iconGreen" style="padding: 0" />
                </v-col>
                <v-col style="text-align: left;padding: 0 0 0 5px;">
                  <span v-if="collateral && collateral.amount">{{ collateral.amount }} €</span>
                  <div>
                    <b>
                      <span>
                        pay
                      </span>
                    </b>
                  </div>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col style="text-align: start">
                  <div>
                    <v-icon color="success">
                      mdi-check-circle-outline
                    </v-icon> {{ collateral.receiver.name }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="auto" style="width: 130px">
            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="15"
              value="100"
              color="green"
              style="left: 50%; transform: translateX(-50%);"
            >
              <v-btn color="primary" class="elevation-0" fab>
                <v-icon dark>
                  fa fa-info
                </v-icon>
              </v-btn>
            </v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-if="collateral && collateral.amount !== -1" justify="center">
          <v-col class="pa-0">
            <p class="ma-0" style="font-weight: bold; margin-top: 2px;font-size: 15px;color: #FF6961">
              {{ $t("Initial Amount") }} {{ collateral.initialAmount }}{{ '€' }}
            </p>
            <p class="ma-0" style="font-weight: bold; margin-top: 2px;font-size: 15px;color: #FF6961">
              {{ $t("Outstanding Amount") }} {{ collateral.initialAmount - collateral.amount }}{{ '€' }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>

export default {
    name: "CollateralView",
    props: {
        collateral: {type: Object, default: null},
    },
    data () {
        return {
            hidden: false,
        };
    },
    created () {
        
    },
    methods: {
        fetch () {
        
        },

    }
};
</script>

<style scoped>
.iconGreen{
    color:var(--v-success-base) !important;
}
</style>
